// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"index__legalContainer__ZL25B","ofAge":"index__ofAge__2lMy7","btnsContainer":"index__btnsContainer__s1iA0","agreeBtn":"index__agreeBtn__M775-"};